import SalesOrderForm from './SalesOrderForm';

export default SalesOrderForm;
